module.exports = __webpack_public_path__ + "html/modal-video_3fe5d059308d4a942cb7e88a5978f4b0.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/modal-video.html
// module id = ldoD
// module chunks = 118